<template>
  <div class="search_home">
    <page-head @changeLang="changeLang"></page-head>
    <!--    banner图-->
    <router-view :lang="lang"></router-view>
    <!--    页脚-->
    <pagefooter></pagefooter>
    <transition name="el-fade-in-linear">
      <div class="backtotop XYcenter" @click="backTop" :title="$t('page.pagefooter_i')" v-if="showtopicon">
        <i class="iconfont iconzhiding size24 colorF"></i>
      </div>
    </transition>
  </div>
</template>

<script>

  import pageHead from '../components/new/pageHead.vue'
  import pagefooter from './pagefooter.vue'

  export default {
    components: {
      pageHead,
      pagefooter
    },
    data() {
      return {
        a:5,
        timer:null,
        lang:'',
        backtop:0,
        showtopicon:false,
      }
    },
    mounted() {
      window.addEventListener("scroll",this.showbtn,true);
    },
    watch:{
      backtop(val){
        if (val > 300) {
          this.showtopicon = true
        }else {
          this.showtopicon = false
        }
      }
    },
    created() {

     /* let ary = [1,2,3]
      let dd = this.aaa(ary) //6
      console.log(dd)*/
    },
    methods: {
      changeLang(lang) {
        this.lang = lang
      },
      /*aaa(arr){
        if(arr.length > 1) {
          let ary = arr.splice(arr.length-1)
          let ary2 = arr.splice(0,arr.length)
          console.log(this.aaa(ary) + this.aaa(ary2),111)
          return this.aaa(ary) + this.aaa(ary2)
        }else if(arr.length === 1) {
          return arr[0]
        }
      },*/
      showbtn(){
        this.backtop = document.body.scrollTop || document.documentElement.scrollTop
      },
      backTop() {
        document.querySelector('body').scrollIntoView({
          behavior: "smooth"
        })
      },
    }
  }
</script>

<style scoped>


  .backtotop {
    width: 40px;
    height: 40px;
    transition: all .3s;
    opacity: .5;
    cursor: pointer;
    border-radius: 6px;
    position: fixed;
    background-color: #289efc;
    right: 20px;
    bottom: 20px;
    z-index: 1000;
  }
  .backtotop:hover{
    opacity: 1;
    background-color: #66b1ff!important;
  }
</style>



// WEBPACK FOOTER //
// src/page/searchHome.vue